// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","inner":"Footer_inner__fhIqU","pitch":"Footer_pitch__fGCdq","links":"Footer_links__q2x7d","meta":"Footer_meta__mk4vA"};